import { getElements, ifSelectorExist } from "./utils";

export const targetFaqItems = () => {
	const faqItems = getElements('.faq-item');
    
	if (ifSelectorExist(faqItems)) {
		faqItems.forEach(function(item) {
			item.addEventListener('click', function() {
				const targetId = item.getAttribute('faq-target');
				const targetElement = document.getElementById(targetId);
				
				if (ifSelectorExist(targetElement)) {
					window.scrollTo(0, targetElement.offsetTop - 200);
				}
			});
		});	
	}
};